import React, { Component } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as func from "../../../../../utils/functions";

import * as Actions from "../../../../../store/modules/resources";
import * as FActions from "../../../../../store/modules/footer";

import EditInput from "../../../../etc/admin/input"
import {STATUS_NAME} from "../../../../../wpconfig";

import JournalPopup from "./JournalPopup"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink} from "@fortawesome/free-solid-svg-icons";

class DefaultForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showPopup: false,
			categoryType: ['register_type', 'resource_type'],
			register_type: [],
			register_type_Name: [],
			resource_type: [],
			resource_type_Name: [],
			showJournalPopup : false,
			searchPopupTitle : '',
			showRegisteredDb : true,
			status : this.props.record.resource_status,
			kri_type : func.getCookie('kri_type') ? func.getCookie('kri_type') : 2
		};
	}

	componentDidMount() {
		this.state.categoryType.map((type, idx) => {
			func.getData("code/search/" + type, {}).then((response) => {
				const t = {}
				t[type] = response.records;
				t[type + "_Name"] = {}
				response.records.map((r, i) => {
					t[type + "_Name"][r.code_id] = r.code_name;
				});
				this.setState(t);
			});
		})

		this.setJournal = this.setJournal.bind(this);
		this.setJournalPopup = this.setJournalPopup.bind(this);
		this.setRegisteredDb = this.setRegisteredDb.bind(this);

		if (this.props.record.registered_db) {
			if (this.props.record.registered_db.length <= 0 ) {
				this.setRegisteredDb(null, null)
			}
		}
	}

	onCheck = (event) => {
		let record = this.props.record;
		let registered_db = record.registered_db

		if(event.target.checked) {
			if(registered_db.includes(event.target.value)) {
			} else {
				registered_db.push(event.target.value)
			}
		} else {
			if(record.registered_db.includes(event.target.value)) {
				const idx = registered_db.indexOf(event.target.value)
				if (idx > -1)
					registered_db.splice(idx, 1)
			}
		}

		record.registered_db = registered_db;

		this.props.dataActions.setResource({"record": record});
		this.forceUpdate()
	};

	togglePopup = () => {
		this.setState({
			showPopup: !this.state.showPopup,
		});
	}

	onUpdate = () => {
		if(this.props.record.kri_wos != document.getElementById('kri_wos').value
			&& document.getElementById('kri_wos').value != '') {
			let record = this.props.record;
			record['kri_wos'] = document.getElementById('kri_wos').value;
			if(this.props.record.wos_id != document.getElementById('wos_id').value
				&& document.getElementById('wos_id').value != '') {
				record['wos_id'] = document.getElementById('wos_id').value;
			}
			this.props.dataActions.setResource({"record": record});
		}
		if(this.props.record.kri_scopus != document.getElementById('kri_scopus').value
			&& document.getElementById('kri_scopus').value != '') {
			let record = this.props.record;
			record['kri_scopus'] = document.getElementById('kri_scopus').value;
			console.log(this.props.record.scopus_id)
			console.log(document.getElementById('scopus_id').value)
			if(this.props.record.scopus_id != document.getElementById('scopus_id').value
				&& document.getElementById('scopus_id').value != '') {
				record['scopus_id'] = document.getElementById('scopus_id').value;
			}
			this.props.dataActions.setResource({"record": record});
		}
		if(this.props.record.kri_kci != document.getElementById('kri_kci').value
			&& document.getElementById('kri_kci').value != '') {
			let record = this.props.record;
			record['kri_kci'] = document.getElementById('kri_kci').value;
			if(this.props.record.kci_id != document.getElementById('kci_id').value
				&& document.getElementById('kci_id').value != '') {
				record['kci_id'] = document.getElementById('kci_id').value;
			}
			this.props.dataActions.setResource({"record": record});
		}
		if(func.getParams("record_id")) {
			func.updateData("admin/resource/" + func.getParams("record_id") + "/update", this.props.record).then((response) => {
				if (response.code === 'ok') {
					this.showMessage('저장 되었습니다.');
					this.setState({
						status : this.props.record.resource_status
					})
				} else {
					this.showMessage('저장 실패 : ' + response.message)
				}
			})
		} else {
			func.updateData("admin/resource/insert", this.props.record).then((response) => {
				if (response.code === 'ok') {
					this.showMessage('저장 되었습니다.');
					location.href = func.changeParamUrl('record_id', response.resource_id);
				} else {
					this.showMessage('저장 실패 : ' + response.message)
				}
			})
		}
	}

	useConfirm = (message = null, onConfirm, onCancel) => {
		if (!onConfirm || typeof onConfirm !== "function") {
			return;
		}
		if (onCancel && typeof onCancel !== "function") {
			return;
		}

		if (window.confirm(message)) {
			onConfirm();
		} else {
			onCancel();
		}
	}

	onDelete = () => {
		func.getParams("record_id") ? (
			this.useConfirm("삭제하시겠습니까?", this.deleteConfirm, this.cancelConfirm)
		) : (
			console.log("레코드 아이디가 없으면 삭제 불가능")
		)
	}

	deleteConfirm = () => {
		func.updateData("admin/resource/" + func.getParams("record_id") + "/delete", this.props.record).then((response) => {
			if (response.code === 'ok') {
				this.showMessage('삭제 되었습니다.');
				this.goLists()
			} else {
				this.showMessage('삭제 실패 : ' + response.message)
			}
		})
	}

	cancelConfirm = () => this.showMessage('취소 되었습니다.');

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	goLists = () => {
		let url = func.removeParamUrl('record_id');
		location.href =  func.removeParamUrl('tab_id', url);
	}

	onChange = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		if(event.target.name === 'journal_title')
			record['journal_id'] = 0
		if(event.target.name === 'publish_year') {
			const regex = /[^0-9]/g;
			let result = event.target.value.replace(regex, "");
			record['indicator_year'] = parseInt(result) - 1
		}
		this.props.dataActions.setResource({"record": record});
		this.forceUpdate()
	}

	textEvent = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.dataActions.setResource({"record": record});
		this.forceUpdate()
	}

	setJournalPopup (status, ks) {
		if(status) {
			this.setState({
				showJournalPopup : status,
				searchPopupTitle : ks ? ks : ''
			})
		} else {
			this.setState({
				showJournalPopup : status,
			})
		}
	}

	setJournal (record) {
		this.setJournalPopup(false, 0);
		let r = this.props.record;
		r.journal_id = record.journal_id
		r.journal_title = record.journal_title
		this.props.dataActions.setResource({"record": r});
		this.setState({showRegisteredDb : false})
		this.forceUpdate();

		this.setRegisteredDb(null, r)
	}

	setRegisteredDb = (event, r) =>  {
		if (event)
			event.preventDefault();

		if(!r)
			r = this.props.record

		delete r['abstract']
		func.getData("admin/resource/" + func.getParams("record_id") + "/registered_db", r).then((response) => {
			if(response.records) {
				r.registered_db = response.records;
				this.props.dataActions.setResource({"record": r});
			}
			this.setState({showRegisteredDb : true})
			this.forceUpdate();
		})
	}

	unChainJournal = (event) => {
		if (confirm("학술지 연결을 해지하시겠습니까?")) {
			let r = this.props.record;
			r.journal_id = 0;
			this.props.dataActions.setResource({"record": r});
			this.forceUpdate();
		}
	}

	onKriVerify =(r) => {
		let kri_type = ''
		if(r == 'wos') {
			kri_type = 2;
			// document.getElementById('kri_scie_checkbox').checked;
		} else if(r == 'scopus') {
			kri_type = 5;
			// document.getElementById('kri_scopus_checkbox').checked;
		} else if(r == 'kci') {
			kri_type = 6;
			// document.getElementById('kri_kci_checkbox').checked;
		} else {
			alert('선택해주세요.')
			return;
		}

		this.setState({kri_type : kri_type})
		func.setCookie('kri_type', kri_type, 999)
		//kri_verify가 2,3,4이면 Kri_Param7에 2,3,4를 전달하고 kri_wos 날짜 입력
		//kri_verify가 5이면 Kri_Param7에 5를 전달하고 kri_scopus에 날짜 입력
		//kri_verify가 6,7이면 Kri_Param7은 널이고,Kri_Param6에 1, 2를 전달하고 kri_kci에 날짜 입력
		const { record } = this.props

		let kri_param6 = ''
		let kri_param7 = ''
		if(r == 'wos') {
			kri_param7='2,3,4'
		} else if(r == 'scopus') {
			kri_param7='5'
		} else if(r == 'kci') {
			kri_param6='1,2'
		}

		// let title = encodeURIComponent(record.resource_title)
		let title = record.resource_title
		// 제목에서 특수문자 제거
		var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
		title = title.replace(regExp, ' ')
		title = title.replace('  ', ' ')
		title = encodeURIComponent(title)
		title = title.replace(/%E2%80%93/gi, '%20') //특수문자'-' 변환

		// &Kri_Param2=10183781
		const kri_verify_url = encodeURIComponent(rmVars.kri_verify_url)
		const u = `https://www.kri.go.kr/kri/ra/cm/sso/wisesso_pop_utf8.jsp?Kri_Param1=${rmVars.kri_verify_id}&Kri_Param4=${title}&Kri_Param5=&Kri_Param6=${kri_param6}&Kri_Param7=${kri_param7}&Kri_Param8=${record.publish_year}&Kri_Param9=${kri_verify_url}&Kri_Service=${rmVars.kri_verify_code}&Kri_certify=${rmVars.kri_verify_pw}&Kri_rshcrRegNo=`
		// 샘플
		// const u = 'https://www.kri.go.kr/kri/ra/cm/sso/wisesso_pop.jsp?Kri_Param1=114000&Kri_Param2=10183781&Kri_Param4=Design+of+composite+layer+and+liner&Kri_Param5=&Kri_Param6=&Kri_Param7=5&Kri_Param8=202101&Kri_Param9=https%3A%2F%2Flib.pusan.ac.kr%2Fdev%2Flee%2Fb.php&Kri_Service=4&Kri_certify=114000&Kri_charset=&Kri_rshcrRegNo='
		// const u = 'https://lib.pusan.ac.kr/dev/lee/b.html'
		const prop = "status=1, toolbar=0, scrollbars=yes, width=920, height=600";
		const myWin = window.open(u, 'name', prop);
	}

	onKriManualVerify =(event) => {
		event.preventDefault();

		if(document.querySelector('input[name="kri_verify"]:checked')) {
			const u = rmVars.kri_manual_verify_url

			const v = document.querySelector('input[name="kri_verify"]:checked').value;
			const id = document.querySelector('input[name="kri_verify"]:checked').id

			const title = document.querySelector('input[name="resource_title"]').value;
			const type = document.querySelector('label[for="'+id+'"]').innerHTML;
			const year = document.querySelector('input[name="publish_year"]').value;

			console.log(year)

			let kri_param6 = ''
			let kri_param7 = ''
			if(v == 2||v == 3||v == 4) {
				kri_param7='2,3,4'
			} else if(v == 5) {
				kri_param7='5'
			} else if(v == 6||v == 7) {
				kri_param6='1,2'
			}

			// &Kri_Param2=10183781
			const kri_verify_url = encodeURIComponent(rmVars.kri_verify_url)
			// &Kri_Param8=${record.publish_year}
			// Kri_Param4=${title}&
			const uu = `${u}?Kri_Param1=${rmVars.kri_verify_id}&Kri_Param5=&Kri_Param6=${kri_param6}&Kri_Param7=${kri_param7}&Kri_Param9=${kri_verify_url}&Kri_Service=${rmVars.kri_verify_code}&Kri_certify=${rmVars.kri_verify_pw}&Kri_rshcrRegNo=&title=${title}&year=${year}&type=${type}`

			const prop = "status=1, toolbar=0, scrollbars=yes, width=920, height=600";
			const myWin = window.open(uu, 'name', prop);
		} else {
			alert('KRI 검증값을 선택해주세요.')
		}
	}

	copy = (val) => {
		const textarea = document.createElement("textarea");
		textarea.value = val;
		// textarea.value = this.props.record.resource_title;
		textarea.style.top = 0;
		textarea.style.left = 0;
		textarea.style.position = "fixed";

		// 흐름 3.
		document.body.appendChild(textarea);
		// focus() -> 사파리 브라우저 서포팅
		textarea.focus();
		// select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
		textarea.select();
		// 흐름 4.
		document.execCommand("copy");
		// 흐름 5.
		document.body.removeChild(textarea);
		// alert("클립보드에 복사되었습니다.");
	}

	setKriType = (e) => {
		func.setCookie('kri_type', event.target.value, 999)
		this.setState({
			'kri_type' : event.target.value
		});
	}

	render() {
		const { togglePopup, onChange, onKriVerify } = this
		const { record } = this.props

		const { textEvent, setKriType } = this
		console.log(record);
		return (
			<>
				<div className="d-flex mt-4 mb-1">
					<h5 className="mr-auto">기본 정보</h5>
					<select className="form-control mr-3"
							name="resource_status" onChange={onChange}
							style={{width : "100px", height: '32px'}}
							value={record.resource_status}>
						{Object.keys(STATUS_NAME).map((item, index) => {
							if(this.state.status !== 'trash' && item === 'delete')
								return ''
							return (<option key={index} value={item}>{STATUS_NAME[item]}</option>)
						})}
					</select>
					<button className="btn btn-sm btn-primary order-0" type="button" id="save_resource" onClick={this.onUpdate}>저장</button>
					{this.state.status === 'trash' &&
					<button className="btn btn-sm btn-danger order-1 ml-2" type="button" id="delete_resource" onClick={this.onDelete}>삭제</button>
					}
					<button className="btn btn-sm btn-secondary order-1 ml-2" type="button" id="show_list" onClick={this.goLists}>리스트</button>
				</div>
				<form>
					<div className="row mb-2">
						<div className="col-md-12 form-main-title">
							<div className="form-group"><label><strong>논문명</strong></label><label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-1" style={{"fontSize":"10px"}} onClick={() => this.copy(record.resource_title)}>복사</label>
								<div>
									<input type="text" name="resource_title" className="form-control" defaultValue={record.resource_title} onChange={this.onChange} />
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<EditInput
								title="번역 논문명"
								value={ record.resource_title_translation }
								name="resource_title_translation"
								onKeyUp={ onChange }
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-3">
							<div className="form-group"><label><strong>최종 문서유형</strong></label>
								<div>
									<select className="form-control form-control-sm"
											value={record.resource_type || ""}
											ref={(ref)=>this.resource_type=ref}
											name="resource_type"
											onChange={textEvent}>
										{this.state.resource_type.length > 0 && this.state.resource_type.map((type, i) => {
											return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
										})}
									</select>
								</div>
							</div>
						</div>
						<div className="col-md-2">
							<EditInput
								title="WoS 문서유형"
								value={ record.wos_doctype }
								name="wos_doctype"
								onKeyUp={ textEvent }
							/>
						</div>
						<div className="col-md-2">
							<EditInput
								title="Scopus 문서유형"
								value={ record.scopus_doctype }
								name="scopus_doctype"
								onKeyUp={ textEvent }
							/>
						</div>
						<div className="col-md-2">
							<EditInput
								title="KCI 문서유형"
								value={ record.kci_doctype }
								name="kci_doctype"
								onKeyUp={ textEvent }
							/>
						</div>
						<div className="col-md-3 form-group">
							<label htmlFor=""><strong>Early Access</strong></label>
							<div className="mt-1">
								<div className="form-check form-check-inline">

									<input className="form-check-input" type="radio" name="early_access" id="early_yes" value="y"
										   checked={(record.early_access || '').toLowerCase() === 'y'} onChange={this.onChange} />
									<label className="form-check-label" htmlFor="early_yes">예</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="early_access" id="early_no" value="n"
										   checked={(record.early_access || '').toLowerCase() !== 'y'} onChange={this.onChange} />
									<label className="form-check-label" htmlFor="early_no">아니오</label>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-3">
							<label htmlFor="input"><strong>WoS ID</strong></label><label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-1" style={{"fontSize":"10px"}} onClick={() => this.copy(record.wos_id)}>복사</label>
							<div className="input-group">
								<input type="text" id="wos_id" name="wos_id" className="form-control"
									   defaultValue={record.wos_id || ""} onKeyUp={ textEvent }/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<a href={"https://www.webofscience.com/wos/woscc/full-record/WOS:" + record.wos_id} target="_blank">
											<FontAwesomeIcon icon={faLink}/>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-3">
							<label htmlFor="input"><strong>Scopus ID</strong></label><label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-1" style={{"fontSize":"10px"}} onClick={() => this.copy(record.scopus_id)}>복사</label>
							<div className="input-group">
								<input type="text" id="scopus_id" name="scopus_id" className="form-control"
									   defaultValue={record.scopus_id || ""} onKeyUp={ textEvent }/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<a href={"https://www.scopus.com/inward/record.uri?partnerID=40&eid=" + record.scopus_id} target="_blank">
											<FontAwesomeIcon icon={faLink}/>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-3">
							<label htmlFor="input"><strong>KCI ID</strong></label><label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-1" style={{"fontSize":"10px"}} onClick={() => this.copy(record.kci_id)}>복사</label>
							<div className="input-group">
								<input type="text" id="kci_id" name="kci_id" className="form-control"
									   defaultValue={record.kci_id || ""} onKeyUp={ textEvent }/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<a href={"https://www.kci.go.kr/kciportal/ci/sereArticleSearch/ciSereArtiView.kci?sereArticleSearchBean.artiId=" + record.kci_id} target="_blank">
											<FontAwesomeIcon icon={faLink}/>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-3 field-success">
							<label htmlFor="input"><strong>DOI</strong></label><label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-1" style={{"fontSize":"10px"}} onClick={() => this.copy(record.doi)}>복사</label>
							<div className="input-group">
								<input type="text" name="doi" className="form-control"
									   defaultValue={record.doi || ""} onKeyUp={ textEvent }/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<a href={"https://doi.org/" + record.doi} target="_blank">
											<FontAwesomeIcon icon={faLink}/>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-6 form-group">
							<label htmlFor=""><strong>KRI 검증 실행</strong></label>
							<div className="mt-1">
								<div className="form-check form-check-inline">
									<label className="btn btn-sm btn-primary p-0 pl-1 pr-1 ml-2" style={{"fontSize":"12px"}} onClick={() => this.onKriVerify('wos')}>WoS검증</label>
								</div>
								<div className="form-check form-check-inline">
									<label className="btn btn-sm btn-primary p-0 pl-1 pr-1 ml-2" style={{"fontSize":"12px"}} onClick={() => this.onKriVerify('scopus')}>Scopus검증</label>
								</div>
								<div className="form-check form-check-inline">
									<label className="btn btn-sm btn-primary p-0 pl-1 pr-1 ml-2" style={{"fontSize":"12px"}} onClick={() => this.onKriVerify('kci')}>KCI검증</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="kri_verify" id="kri_scie_checkbox"
										   checked={this.state.kri_type == '2'}
										   value="2" onChange={this.setKriType} />
									<label className="form-check-label" htmlFor="kri_scie_checkbox">SCIE</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="kri_verify" id="kri_scopus_checkbox"
										   checked={this.state.kri_type == '5'}
										   value="5" onChange={this.setKriType} />
									<label className="form-check-label" htmlFor="kri_scopus_checkbox">Scopus</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="kri_verify" id="kri_kci_checkbox"
										   checked={this.state.kri_type == '6'}
										   value="6" onChange={this.setKriType}/>
									<label className="form-check-label" htmlFor="kri_kci_checkbox">KCI</label>
								</div>
								<div className="form-check form-check-inline">
									<a href="#" onClick={this.onKriManualVerify}><label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-1" style={{"fontSize":"12px"}}>수동검사</label></a>
								</div>
								<div className="form-check form-check-inline">
									<span className="pl-2">검증 제외인 경우 'no'입력</span>
								</div>
							</div>
						</div>
						<div className="col-md-2">
							<label htmlFor="input"><strong>KRI WoS 검증</strong></label>
							<div className="input-group">
								<input type="text" name="kri_wos" id="kri_wos" className="form-control"
									   value={record.kri_wos || ''} onChange={ textEvent }/>
							</div>
						</div>
						<div className="col-md-2">
							<label htmlFor="input"><strong>KRI Scopus 검증</strong></label>
							<div className="input-group">
								<input type="text" name="kri_scopus" id="kri_scopus" className="form-control"
									   value={record.kri_scopus || ''} onChange={ textEvent }/>
							</div>
						</div>
						<div className="col-md-2">
							<label htmlFor="input"><strong>KRI KCI 검증</strong></label>
							<div className="input-group">
								<input type="text" name="kri_kci" id="kri_kci" className="form-control"
									   value={record.kri_kci || ''} onChange={ textEvent }/>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-7 form-group">
							{/* <EditInput
								title="학술지 명"
								value={ record.journal_title }
								name="journal_title"
								onKeyUp={ onChange }
							/> */}
							<label htmlFor="journal_title" className="text-danger"><strong>학술지</strong></label><label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-1" style={{"fontSize":"10px"}} onClick={() => this.copy(record.journal_title)}>복사</label>
							<div className="input-group field-danger">
								<input
									type="text"
									name="journal_title"
									className="form-control"
									ref={(ref)=>this.journal_title=ref}
									value={record.journal_title || ""}
									onChange={onChange}
								/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<span className="search-icon" onClick={() => this.setJournalPopup(true, record.journal_title)}></span>
									</div>
								</div>
								{
									record.journal_id ? (
											<>
												<div className="icon-flex-center">
													<a href="#" onClick={() => window.open("admin.php?page=journal&record_id=" + this.props.record.journal_id, '_blank')}>
														<span className="ml-1 link-icon align-middle" />
													</a>
													<span className="ml-1 unlink-icon" onClick={this.unChainJournal} />
												</div>
											</>
										) :
										""
								}
							</div>
						</div>
						<div className="col-md-5">
							<EditInput
								title="ISSN"
								value={ record.issn }
								name="issn"
								onKeyUp={ onChange }
							/>
						</div>
					</div>
					{this.state.showRegisteredDb &&
					<div className="row mb-4">
						<div className="col-md-12 form-group">
							<label htmlFor="journal_title"><strong>등재 정보</strong></label>
							<label className="btn btn-outline-success btn-sm p-0 pl-1 pr-1 ml-2" style={{"fontSize":"10px"}} onClick={() => this.setRegisteredDb(event)}>새로고침</label>
							<div className="input-group">
								{
									this.state.register_type.map((data, idx) => {
										return (
											<div className="form-check form-check-inline mr-4" key={idx}>
												<input className="form-check-input" type="checkbox" id={`inlineCheckbox${idx}`}
													   name={data.code_id} value={data.code_id} onChange={this.onCheck}
													   checked={record.registered_db.includes(data.code_id) ? "checked" : ""}/>
												<label className="form-check-label" htmlFor={`inlineCheckbox${idx}`}>{data.code_name}</label>
											</div>
										)
									})
								}
							</div>
						</div>
					</div>
					}
					<div className="row mb-2">
						<div className="col-md-2 field-success">
							<EditInput
								title="발행년도"
								value={ record.publish_year }
								name="publish_year"
								onKeyUp={ onChange }
							/>
						</div>
						<div className="col-md-2">
							<EditInput
								title="Volume"
								value={ record.volume }
								name="volume"
								onKeyUp={ onChange }
							/>
						</div>
						<div className="col-md-2">
							<EditInput
								title="Issue"
								value={ record.issue }
								name="issue"
								onKeyUp={ onChange }
							/>
						</div>
						<div className="col-md-6 form-group">
							<label><strong>Pages</strong></label>
							<div className="row pages">
								<div className="input-group col-md-6">
									<input type="text" className="form-control" name="start_page" value={ record.start_page || "" } onChange={onChange} />
									<span className="input-group-text">~</span>
									<input type="text" className="form-control" name="end_page" value={ record.end_page || "" } onChange={onChange} />
								</div>
								<div className="input-group col-md-6">
									<span className="input-group-text">총</span>
									<input type="text" className="form-control" name="total_page" value={ record.total_page || "" } onChange={onChange} />
									<span className="input-group-text">Pages</span>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-3 field-danger">
							<div className="form-group"><label><strong>평가지표년도(Indicator Year)</strong></label>
								<div>
									<input type="text" name="indicator_year" className="form-control" value={ record.indicator_year || "" } onChange={onChange} />
								</div>
							</div>
						</div>
						<div className="col-md-3 field-success">
							<EditInput
								title="논문 발행일(YYYY-MM-DD)"
								value={ record.publish_date }
								name="publish_date"
								onKeyUp={ textEvent }
							/>
						</div>
						<div className="col-md-3">
							<EditInput
								title="논문 접수일"
								value={ record.receipt_date }
								name="receipt_date"
								onKeyUp={ textEvent }
							/>
						</div>
						<div className="col-md-3">
							<EditInput
								title="게재 확정일"
								value={ record.confirm_date }
								name="confirm_date"
								onKeyUp={ textEvent }
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-3">
							<div className="form-group">
								<label><strong>등록일(수집일)</strong></label>
								<p className="mb-1">{ record.register_date }</p>
							</div>
						</div>
						<div className="col-md-3">
							<div className="form-group">
								<label><strong>입력일</strong></label>
								<p className="mb-1">{ record.input_date }</p>
							</div>
						</div>
						<div className="col-md-3">
							<div className="form-group">
								<label><strong>수정일</strong></label>
								<p className="mb-1">{ record.modified_date }</p>
							</div>
						</div>
						{/* <div className="col-md-4 form-group">
							<label><strong>원문파일</strong></label>
							<div className="input-group">
								<button className="btn btn-outline-secondary btn-sm" type="button" id="">체크아이콘</button>
							</div>
						</div> */}
					</div>


					<div className="row mt-4">
						<div className="col-md-12">
							<div className="bd-callout bd-callout-warning border p-3">
								<h5 id="conveying-meaning-to-assistive-technologies">저널 카테고리 정보</h5>
								{
									record.journal_category &&
									record.journal_category.map((data, idx) => {
										return (
											<div key={idx} className="">
												<h6>{ data.category_type }</h6>
												<p>{ data.category_names }</p>
											</div>
										)
									})
								}
							</div>
						</div>
					</div>
				</form>
				{/*<JournalDataPopup />*/}

				{this.state.showJournalPopup &&
				<JournalPopup
					showJournalPopup={this.state.showJournalPopup}
					ks={this.state.searchPopupTitle}
					set={this.setJournal}
					showMessage={this.showMessage}
					setJournalPopup={this.setJournalPopup}
				/>
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.resources.record ? state.resources.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
) (DefaultForm)
